/*
 * Single source of truth for every phone number and messaging link the public
 * site renders. No component may hardcode a number string — import from here.
 *
 * [BRACKETED_TOKENS] are unresolved placeholders still owed by the owner —
 * grep for "[" values here before launch. Consumers must not fall back to the
 * primary number when a placeholder is unresolved; they render a visible
 * NEEDS_NUMBER state instead so a missing value can't ship silently.
 */

export const PHONE_PRIMARY = '9654502028';
export const PHONE_PRIMARY_E164 = '+919654502028';
export const PHONE_PRIMARY_DISPLAY = '+91 96545 02028';

export const WHATSAPP_E164 = '+919654502028'; // confirmed: same as primary
export const WHATSAPP_PREFILL_MESSAGE =
  "Hi, I'd like to know about admissions and batches at Future Makers.";

/*
 * The second centre's own line. TRIGGER TO FILL THESE: the pending per-centre
 * phone-number split — today both centre blocks in the footer display and dial
 * the primary number, which is correct and matches both live Google Business
 * Profile listings. Resolve these only when the institute actually runs a
 * separate line for the second centre.
 *
 * READ THIS BEFORE FILLING THEM IN: both centre call buttons currently route
 * through the same `centreTelHref` expression in LandingShell.js, so resolving
 * these values switches BOTH centres onto the secondary number at once. The
 * split needs a per-centre mapping (which centre is "second"?) at the same
 * time — filling these alone is not sufficient and would misroute one centre.
 */
export const PHONE_SECONDARY_DISPLAY = '[SECOND_CENTRE_NUMBER_DISPLAY]';
export const PHONE_SECONDARY_E164 = '[SECOND_CENTRE_NUMBER_E164]';

/* True once a placeholder token has been replaced with a real value. */
export const isResolved = (value) => typeof value === 'string' && !value.startsWith('[');

export const TEL_PRIMARY_HREF = `tel:${PHONE_PRIMARY_E164}`;

/*
 * wa.me wants the E164 number without the leading "+". Null while the WhatsApp
 * number is an unresolved placeholder, so no consumer can build a garbage link
 * by accident — render the NEEDS_NUMBER state on null instead.
 */
export const WHATSAPP_URL = isResolved(WHATSAPP_E164)
  ? `https://wa.me/${WHATSAPP_E164.replace('+', '')}${
      isResolved(WHATSAPP_PREFILL_MESSAGE)
        ? `?text=${encodeURIComponent(WHATSAPP_PREFILL_MESSAGE)}`
        : ''
    }`
  : null;
